import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "biometrics-lock-preference"

  connect() {
    super.connect()
    this.syncPreference()
  }

  syncPreference() {
    const raw = this.element?.dataset?.biometricsLockLifecycleEnabledValue
    if (raw === undefined || raw === "") return
    const enabled = raw === "true"
    this.send("sync", { enabled })
  }

  syncFromToggle(event) {
    const enabled = event.detail?.enabled === true
    this.send("sync", { enabled })
  }
}
